import PropTypes from 'prop-types';
import React from 'react';

import ModalV4 from "../../../app/ui/modal/v4/v4";

import CreateExisting from './create-existing';
import CreateNew from './create-new';
import CreateNoAccess from './create-no-access';

const propTypes = {
    params: PropTypes.object.isRequired
};

class StatusModalCreate extends ModalV4 {

    constructor(props) {
        super(props);
        const { statusId, newOnly } = props.params;

        this.state = {
            curValue: newOnly ? "new" : "existing",
            statusId: statusId ? statusId : null
        }
    }

    onClickNew = () => {
        this.setState({curValue:"new"});
    }

    onClickNoAccess = () => {
        this.setState({curValue:"noAccess"});
    }

    onAddExisting = (id) => {
        this.props.params.onSubmit({statusId:id});
    }

    onAddSuggested = (id) => {
        this.setState({
            curValue:"new",
            statusId: id
        });
    }

    onClickBack = () => {
        this.setState({curValue:"existing"});
    }

    onSubmit = (result) => {
        this.forceUpdate();
        this.props.params.onSubmit.call(this.props.params.this,result);
    }

    render() {
        let res;
        switch (this.state.curValue){
            case "existing":
                res = <CreateExisting onAddExisting={this.onAddExisting}
                                      onAddSuggested={this.onAddSuggested}
                                      onClickNew={this.onClickNew}
                                      onClickNoAccess={this.onClickNoAccess}
                                      onClick={this.stopPropagation}
                                      params={this.props.params}/>;
                break;

            case "new":
                res = <CreateNew onSubmit={this.onSubmit}
                                 params={this.props.params}
                                 statusId={this.state.statusId}
                                 onClickBack={this.onClickBack}
                                 onClick={this.stopPropagation}/>;
                break;

            case "noAccess":
                res = <CreateNoAccess onClick={this.stopPropagation}
                                      onClickBack={this.onClickBack}/>;
                break;
        }
        return res;
    }
}

StatusModalCreate.propTypes = propTypes;

module.exports = StatusModalCreate;